import * as React from 'react';
import { createIllustration } from '@balance-web/illustration';

export const ReckonPayrollLogoName = 'ReckonPayrollLogo';
export const ReckonPayrollAppName = 'Payroll';
export const ReckonPayrollAppLongName = 'Reckon Payroll';
export const ReckonPayrollLogoDescription = 'Reckon Payroll Application Logo';

export const ReckonPayrollLogo = createIllustration(
  {
    name: ReckonPayrollLogoName,
    description: ReckonPayrollLogoDescription,
    width: 60,
    height: 60,
  },
  <React.Fragment>
    <mask
      height={60}
      id="b"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={60}
      x={0}
      y={0}
    >
      <path
        d="M0 14C0 6.268 6.268 0 14 0h32c7.732 0 14 6.268 14 14v32c0 7.732-6.268 14-14 14H14C6.268 60 0 53.732 0 46V14Z"
        fill="url(#a)"
      />
    </mask>
    <mask
      height={60}
      id="d"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={60}
      x={0}
      y={0}
    >
      <path
        d="M0 14C0 6.268 6.268 0 14 0h32c7.732 0 14 6.268 14 14v32c0 7.732-6.268 14-14 14H14C6.268 60 0 53.732 0 46V14Z"
        fill="url(#c)"
      />
    </mask>
    <g mask="url(#d)">
      <path d="M0 0h60v60H0z" fill="url(#e)" />
      <path
        clipRule="evenodd"
        d="M21.652 29.437c3.88 0 7.024-3.017 7.024-6.739 0-3.721-3.145-6.739-7.024-6.739-3.88 0-7.025 3.017-7.025 6.74 0 3.72 3.144 6.738 7.025 6.738Zm7.435 3.192c-.248.12-.498.24-.705.399-3.408 2.219-4.165 7.465-4.375 10.328H11.346c-.38 0-.715-.161-.968-.404a1.415 1.415 0 0 1-.378-.968c.043-1.17.337-6.98 3.155-8.837 2.23-1.451 7.025-1.573 8.455-1.573 1.261 0 5.047.082 7.487 1.05l-.01.005ZM50 43.843c-.043-1.454-.42-6.901-3.154-8.635-2.23-1.453-7.024-1.573-8.455-1.573-1.43 0-6.226.121-8.455 1.573-2.818 1.857-3.112 7.667-3.155 8.837 0 .362.127.685.378.968.253.242.63.403.968.403H48.61c.757 0 1.388-.605 1.388-1.332.002-.12.002-.2.002-.241ZM38.391 31.535c3.88 0 7.025-3.017 7.025-6.739 0-3.721-3.144-6.739-7.025-6.739-3.879 0-7.024 3.018-7.024 6.74 0 3.72 3.145 6.738 7.024 6.738Z"
        fill="#fff"
        fillRule="evenodd"
      />
      <g filter="url(#f)">
        <path d="M60 19 19 60h41V19Z" fill="#fff" fillOpacity={0.2} />
      </g>
      <path
        clipRule="evenodd"
        d="M41.361 43.815v9.735H51.1a2.377 2.377 0 0 0 2.374-2.373v-7.362a2.377 2.377 0 0 0-2.374-2.373h-7.364a2.377 2.377 0 0 0-2.374 2.373Zm-1 10.735H51.1a3.377 3.377 0 0 0 3.374-3.373v-7.362a3.377 3.377 0 0 0-3.374-3.373h-7.364a3.377 3.377 0 0 0-3.374 3.373V54.55Z"
        fill="#fff"
        fillRule="evenodd"
      />
      <path
        d="M44.566 43.721h3.36c.951 0 1.688.281 2.17.75.402.415.63.963.63 1.62v.026c0 1.232-.737 1.981-1.782 2.276l2.036 2.85H49.4l-1.848-2.623h-1.66v2.624h-1.326V43.72Zm3.267 3.735c.95 0 1.553-.496 1.553-1.259v-.026c0-.803-.576-1.245-1.566-1.245h-1.928v2.53h1.941Z"
        fill="#fff"
      />
    </g>
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="a"
        x1={0}
        x2={62.099}
        y1={0}
        y2={57.743}
      >
        <stop stopColor="#F88B00" />
        <stop offset={1} stopColor="#FFB027" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="c"
        x1={0}
        x2={62.099}
        y1={0}
        y2={57.743}
      >
        <stop stopColor="#F88B00" />
        <stop offset={1} stopColor="#FFB027" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="e"
        x1={0}
        x2={62.099}
        y1={0}
        y2={57.743}
      >
        <stop stopColor="#FFAC4B" />
        <stop offset={1} stopColor="#F84184" />
      </linearGradient>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height={57}
        id="f"
        width={57}
        x={11}
        y={11}
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={4} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_14050_1131"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_14050_1131"
          result="shape"
        />
      </filter>
    </defs>
  </React.Fragment>
);
